import {
    GET_TAGS_BY_VARIANT_ID,
    UPSERT_ALL_VARIANTS_TAGS,
    DELETE_ALL_VARIANTS_TAGS,
    DELETE_TAGS_BY_VARIANT_IDS,
    DELETE_TAGS_BY_VARIANT_ID,
    UPSERT_TAGS_BY_VARIANT_ID,
    GET_DISCOUNTS_BY_VARIANT_ID,
    UPDATE_DISCOUNTS_BY_VARIANT_ID
} from "../Api";
import { apiRequestToastAsync } from "../../functions/FetchWithToast";

export const updateDiscountsByVariantId = (id, data) => apiRequestToastAsync({
    request_details: UPDATE_DISCOUNTS_BY_VARIANT_ID(id, data),
    messages: {
        loading: `Updating discounts for variant ${id}`,
        done: `Updated discounts for variant ${id}`,
        error: `Error updating discounts for variant ${id}`
    }
});

export const getDiscountsByVariantId = (id) => apiRequestToastAsync({
    request_details: GET_DISCOUNTS_BY_VARIANT_ID(id),
    messages: {
        loading: `Featching discounts for variant ${id}`,
        done: `Loaded discounts for variant ${id}`,
        error: `Error discounts for variant ${id}`
    }
});

export const getTagsByVariantId = (id) => apiRequestToastAsync({
    request_details: GET_TAGS_BY_VARIANT_ID(id),
    messages: {
        loading: `Featching tags for variant ${id}`,
        done: `Loaded tags for variant ${id}`,
        error: `Error getting for variant ${id}`
    }
});

export const upsertAllVariantsAndTags = (data) => apiRequestToastAsync({
    request_details: UPSERT_ALL_VARIANTS_TAGS(data),
    messages: {
        loading: 'Saving batch',
        done: 'Batch saved',
        error: 'Error saving batch'
    }
});

export const deleteAllTagsFromVariants = (data) => apiRequestToastAsync({
    request_details: DELETE_ALL_VARIANTS_TAGS(data),
    messages: {
        loading: 'Deleting batch',
        done: 'Batch deleted',
        error: 'Error deleting batch'
    }
});

export const deleteTagsByVariantIds = (variantIds) => apiRequestToastAsync({
    request_details: DELETE_TAGS_BY_VARIANT_IDS(variantIds),
    messages: {
        loading: 'Deleting all tags from variants',
        done: 'Variant tags deleted',
        error: 'Error deleting variant tags'
    }
});

export const deleteTagsByVariantId = (variantId) => apiRequestToastAsync({
    request_details: DELETE_TAGS_BY_VARIANT_ID(variantId),
    messages: {
        loading: 'Deleting all tags from variant',
        done: 'Variant tags deleted',
        error: 'Error deleting variant tags'
    }
});

export const upsertTagsByVariantId = (data) => apiRequestToastAsync({
    request_details: UPSERT_TAGS_BY_VARIANT_ID(data),
    messages: {
        loading: 'Saving variant tags',
        done: 'Variant tags saved',
        error: 'Error saving variant tags'
    }
});